export const renderInitialCircle = (inputString?: string) => {
  // Get the first character and make it uppercase
  const initial = inputString?.charAt(0).toUpperCase();

  // Simple hash function to convert string to a "dark" color
  const stringToColor = (str?: string) => {
    if (!str) return '#000000';
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    let color = '#';
    for (let i = 0; i < 3; i++) {
      let value = (hash >> (i * 8)) & 0xff;
      // Ensure it's a "dark" color by limiting the color value
      value = (value / 2) | 0; // Bitwise OR with zero ensures a whole number
      color += ('00' + value.toString(16)).substr(-2);
    }
    return color;
  };

  // Generate a lighter color for the gradient
  const lightenColor = (color: string, percent: number) => {
    const num = parseInt(color.slice(1), 16);
    const amt = Math.round(2.55 * percent);
    const R = (num >> 16) + amt;
    const B = ((num >> 8) & 0x00ff) + amt;
    const G = (num & 0x0000ff) + amt;
    return (
      '#' +
      (0x1000000 + (R < 255 ? R : 255) * 0x10000 + (B < 255 ? B : 255) * 0x100 + (G < 255 ? G : 255))
        .toString(16)
        .slice(1)
    );
  };

  // Convert the input string to a dark hex color
  const darkColor = stringToColor(inputString);
  const lightColor = lightenColor(darkColor, 30);

  return (
    <div
      className="w-full h-full rounded-full flex items-center justify-center text-white font-bold text-xl"
      style={{ background: `linear-gradient(75deg, ${lightColor}, ${darkColor})` }}
    >
      {initial}
    </div>
  );
};
